import React from "react";
import {Row,Col,Container} from "react-bootstrap"
import { useSelector} from "react-redux"
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom'
import { delLogin } from "../Magazyn/kreatorAkcji";
const Uczestnik  = () => {
    const uczestnik = useSelector((magazyn) => magazyn.uczestnik)
    const nawigacja = useNavigate()
    const dispach   = useDispatch()
    const koniec = () =>{
        sessionStorage.clear()
        dispach(delLogin({}))
        let url = '/'
         nawigacja(url)
    }

    return( 
        <Container>
            <Row className= "uczestnik" key={uczestnik.id}>
                <Col xs={3}><h2 className="napis_login" >Uczestnik : </h2></Col>
                <Col xs={3}><h2>{uczestnik.nazwisko}</h2></Col>
                <Col xs={3}><h2>{uczestnik.imie}</h2></Col>
                <Col xs={3}><button onClick={koniec} className='btn btn-lg btn-primary' type="button">Koniec</button></Col>
            </Row> 
        </Container>
        )
}

export default Uczestnik